import { render, staticRenderFns } from "./EventModalCatalogRubrics.vue?vue&type=template&id=e02411e2&scoped=true"
import script from "./EventModalCatalogRubrics.vue?vue&type=script&lang=js"
export * from "./EventModalCatalogRubrics.vue?vue&type=script&lang=js"
import style0 from "./EventModalCatalogRubrics.vue?vue&type=style&index=0&id=e02411e2&prod&lang=scss&scoped=true"
import style1 from "./EventModalCatalogRubrics.vue?vue&type=style&index=1&id=e02411e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02411e2",
  null
  
)

export default component.exports